import * as userActions from 'redux/actions/user.actions'
import * as adminActions from 'redux/actions/admin.actions'
import * as accountActions from 'redux/actions/account.actions'
import * as domainsDataActions from 'redux/actions/domainsData.actions'
import * as dashboardActions from 'redux/actions/dashboard.actions'
import * as keywordPagesActions from 'redux/actions/keywordPages.actions'
import * as keywordFinderActions from 'redux/actions/keywordFinder.actions'
import * as serpCheckerActions from 'redux/actions/serpChecker.actions'
import * as backlinkCheckerActions from 'redux/actions/backlinkChecker.actions'
import * as keywordDiscoveryActions from 'redux/actions/keywordDiscovery.actions'
import * as keywordGrossingActions from 'redux/actions/keywordGrossing.actions'
import * as listActions from 'redux/actions/list.actions'
import * as favouriteLinksActions from 'redux/actions/favouriteLinks.actions'
import * as notificationsActions from 'redux/actions/notification.actions'
import * as reportsActions from 'redux/actions/reports.actions'
import * as seoChecklistActions from 'redux/actions/seoChecklist.actions'
import * as billingActions from 'redux/actions/billing.actions'

const initialState = {
  adminLoading: false,
  dashboardLoading: {
    domains: false,
    websiteAudit: false,
    seoSavings: false,
    notifications: false,
    seoChecklist: false,
    keywordFinder: false,
    reports: false,
    overview: false,
    movements: false
  },
  domainsLoading: false,
  domainsIdsLoading: {},
  keywordFinderHistory: false,
  serpCheckerHistory: false,
  backlinkCheckerHistory: false,
  keywordsLoading: false,
  keywordsResultsLoading: false,
  keywordsChangesLoading: false,
  keywordsCompetitorsResultsLoading: false,
  keywordsCompetitorsChangesLoading: false,
  competitorsLoading: false,
  grossingLoading: false,
  discoveryLoading: false,
  savingsLoading: false,
  notificationLoading: true,
  pagesLoading: false,
  pagesChangesLoading: false,
  listsLoading: false,
  listLoading: false,
  favouritesListsLoading: false,
  favouritesListLoading: false,
  tagsLoading: false,
  seoChecklistDomainsLoading: false,
  invoicesLoading: false
}

const statusReducer = (state = initialState, { type, payload = {} }) => {
  switch (type) {
    case adminActions.getAdminUsers.type:
    case adminActions.getAdminUserDomains.type:
      return {
        ...state,
        adminLoading: true
      }
    case adminActions.getAdminUsersSuccess.type:
    case adminActions.getAdminUsersFailure.type:
    case adminActions.getAdminUserDomainsSuccess.type:
    case adminActions.getAdminUserDomainsFailure.type:
      return {
        ...state,
        adminLoading: false
      }
    case domainsDataActions.loadDomain.type:
    case domainsDataActions.loadDomainExtended.type:
    case domainsDataActions.flagGetDomainData.type:
      return {
        ...state,
        domainsLoading: true,
        domainsIdsLoading: {
          ...state.domainsIdsLoading,
          [payload.id]: true
        }
      }
    case domainsDataActions.loadDomainSuccess.type:
      return {
        ...state,
        domainsLoading: false,
        domainsIdsLoading: {
          ...state.domainsIdsLoading,
          [payload.id]: false
        }
      }
    case dashboardActions.getDashboardData.type:
      return {
        ...state,
        dashboardLoading: {
          domains: true,
          websiteAudit: true,
          seoSavings: true,
          notifications: true,
          seoChecklist: true,
          keywordFinder: true,
          reports: true,
          overview: true,
          movements: true
        }
      }
    case dashboardActions.getDashboardDomainsSuccess.type:
      return {
        ...state,
        dashboardLoading: {
          ...state.dashboardLoading,
          domains: false
        }
      }
    case dashboardActions.getDashboardDataSuccess.type:
    case dashboardActions.getDashboardDataFailure.type:
      if (payload.payload?.key) {
        return {
          ...state,
          dashboardLoading: {
            ...state.dashboardLoading,
            [payload.payload.key]: false
          }
        }
      }
      return {
        ...state,
        dashboardLoading: {
          domains: false,
          websiteAudit: false,
          seoSavings: false,
          notifications: false,
          seoChecklist: false,
          keywordFinder: false,
          reports: false,
          overview: false,
          movements: false
        }
      }
    case keywordFinderActions.getKeywordFinderHistory.type:
      return {
        ...state,
        keywordFinderHistory: true
      }
    case keywordFinderActions.getKeywordFinderHistorySuccess.type:
    case keywordFinderActions.getKeywordFinderHistoryFailure.type:
      return {
        ...state,
        keywordFinderHistory: false
      }
    case backlinkCheckerActions.getHistory.type:
      return {
        ...state,
        backlinkCheckerHistory: true
      }
    case backlinkCheckerActions.getHistorySuccess.type:
    case backlinkCheckerActions.getHistoryFailure.type:
      return {
        ...state,
        backlinkCheckerHistory: false
      }
    case serpCheckerActions.getSerpCheckerHistory.type:
      return {
        ...state,
        serpCheckerHistory: true
      }
    case serpCheckerActions.getSerpCheckerHistorySuccess.type:
    case serpCheckerActions.getSerpCheckerHistoryFailure.type:
      return {
        ...state,
        serpCheckerHistory: false
      }
    case domainsDataActions.loadKeywords.type:
      return {
        ...state,
        keywordsLoading: true
      }
    case domainsDataActions.loadKeywordsSuccess.type:
      return {
        ...state,
        keywordsLoading: false,
        keywordsResultsLoading: true,
        keywordsChangesLoading: true
      }
    case domainsDataActions.loadDomainTags.type:
      return {
        ...state,
        tagsLoading: true
      }
    case domainsDataActions.loadDomainTagsSuccess.type:
      return {
        ...state,
        tagsLoading: false
      }

    case domainsDataActions.loadCompetitors.type:
      return {
        ...state,
        competitorsLoading: true
      }
    case domainsDataActions.loadCompetitorsSuccess.type:
      return {
        ...state,
        competitorsLoading: false
      }
    case domainsDataActions.loadKeywordsResultsSuccess.type:
      return {
        ...state,
        keywordsResultsLoading: false
      }
    case domainsDataActions.loadKeywordsChangesSuccess.type:
      return {
        ...state,
        keywordsChangesLoading: false
      }
    case domainsDataActions.loadKeywordsFailure.type:
      return {
        ...state,
        keywordsLoading: true,
        keywordsResultsLoading: false,
        keywordsChangesLoading: false
      }
    case domainsDataActions.loadKeywordsCompetitors.type:
      return {
        ...state,
        keywordsCompetitorsResultsLoading: true,
        keywordsCompetitorsChangesLoading: true
      }
    case domainsDataActions.loadKeywordsCompetitorsResultsSuccess.type:
      return {
        ...state,
        keywordsCompetitorsResultsLoading: false
      }
    case domainsDataActions.loadKeywordsCompetitorsChangesSuccess.type:
      return {
        ...state,
        keywordsCompetitorsChangesLoading: false
      }

    case keywordPagesActions.getPages.type:
      return {
        ...state,
        pagesLoading: true
      }
    case keywordPagesActions.getPagesSuccess.type: {
      return {
        ...state,
        pagesLoading: false
      }
    }
    case keywordPagesActions.getPagesChanges.type:
      return {
        ...state,
        pagesChangesLoading: true
      }
    case keywordPagesActions.getPagesChangesSuccess.type: {
      return {
        ...state,
        pagesChangesLoading: false
      }
    }
    case keywordGrossingActions.getDomainKeywordGrossing.type:
      return {
        ...state,
        grossingLoading: true
      }
    case keywordGrossingActions.getDomainKeywordGrossingSuccess.type:
      return {
        ...state,
        grossingLoading: false
      }
    case keywordDiscoveryActions.getDomainKeywordDiscovery.type:
      return {
        ...state,
        discoveryLoading: true
      }
    case keywordDiscoveryActions.getDomainKeywordDiscoverySuccess.type:
      return {
        ...state,
        discoveryLoading: false
      }
    case notificationsActions.getNotificationOverview.type:
      return {
        ...state,
        notificationLoading: true
      }
    case notificationsActions.getNotificationOverviewSuccess.type:
      return {
        ...state,
        notificationLoading: false
      }
    case listActions.getLists.type:
      return {
        ...state,
        listsLoading: true
      }
    case listActions.getListsSuccess.type:
      return {
        ...state,
        listsLoading: false
      }
    case listActions.getList.type:
      return {
        ...state,
        listLoading: true
      }
    case listActions.getListSuccess.type:
      return {
        ...state,
        listLoading: false
      }
    case favouriteLinksActions.getFavouritesLists.type:
      return {
        ...state,
        favouritesListsLoading: true
      }
    case favouriteLinksActions.getFavouritesListsSuccess.type:
      return {
        ...state,
        favouritesListsLoading: false
      }
    case favouriteLinksActions.getFavouritesList.type:
      return {
        ...state,
        favouritesListLoading: true
      }
    case favouriteLinksActions.getFavouritesListSuccess.type:
      return {
        ...state,
        favouritesListLoading: false
      }
    case reportsActions.loadDomains.type:
      return {
        ...state,
        domainsLoading: true
      }
    case reportsActions.loadDomainsSuccess.type:
    case reportsActions.loadDomainsFailure.type:
      return {
        ...state,
        domainsLoading: false
      }
    case seoChecklistActions.getSeoChecklistDomains.type:
      return {
        ...state,
        seoChecklistDomainsLoading: true
      }
    case seoChecklistActions.getSeoChecklistDomainsSuccess.type:
    case seoChecklistActions.getSeoChecklistDomainsFailure.type:
      return {
        ...state,
        seoChecklistDomainsLoading: false
      }
    case billingActions.loadInvoices.type:
      return {
        ...state,
        invoicesLoading: true
      }
    case billingActions.loadInvoicesSuccess.type:
      return {
        ...state,
        invoicesLoading: false
      }
    case accountActions.getAccountDataFailure.type:
    case userActions.logout.type:
      return initialState
    default:
      return state
  }
}
export default statusReducer
